import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faMapMarkerAlt, faBuilding, faHashtag } from '@fortawesome/free-solid-svg-icons';
import { Cliente } from '../types';

interface ClientDataProps {
  cliente: Cliente;
}

export const ClientData: React.FC<ClientDataProps> = ({ cliente }) => {
  return (
    <div className="card client-data">
      <div className="card-header">
        <FontAwesomeIcon icon={faUser} className="card-icon" size="lg" />
        <h2>Dados do Cliente</h2>
      </div>
      
      <div className="client-info">
        <div className="info-item">
          <FontAwesomeIcon icon={faUser} className="info-icon" />
          <span className="info-label">Nome:</span>
          <span className="info-value">{cliente['name_cliente']}</span>
        </div>
        
        <div className="info-item">
          <FontAwesomeIcon icon={faEnvelope} className="info-icon" />
          <span className="info-label">Email:</span>
          <span className="info-value">{cliente['email_cliente']}</span>
        </div>
        
        {cliente['end_ciente'] && (
          <div className="info-item">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="info-icon" />
            <span className="info-label">Endereço:</span>
            <span className="info-value">{cliente['end_ciente']}</span>
          </div>
        )}
        
        {cliente['cidade'] && (
          <div className="info-item">
            <FontAwesomeIcon icon={faBuilding} className="info-icon" />
            <span className="info-label">Cidade:</span>
            <span className="info-value">{cliente['cidade']}</span>
          </div>
        )}
        
        {cliente['estado'] && (
          <div className="info-item">
            <span className="info-label">Estado:</span>
            <span className="info-value">{cliente['estado']}</span>
          </div>
        )}
        
        {cliente['cep'] && (
          <div className="info-item">
            <FontAwesomeIcon icon={faHashtag} className="info-icon" />
            <span className="info-label">CEP:</span>
            <span className="info-value">{cliente['cep']}</span>
          </div>
        )}
      </div>
    </div>
  );
};
